import { FC } from 'react'
import { Typography, OutlinedInput, InputProps } from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { FormControl } from './styles/controlledTextField.styles'
import theme from 'theme'

const muiTheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': {
            WebkitBackgroundClip: 'text !important',
            WebkitTextFillColor: theme.baseColors.greyscale[80]
          },
          '&::placeholder': {
            overflow: 'hidden',
            color: theme.colors.textSecondaryLow,
            textOverflow: 'ellipsis',
            fontSize: theme.typography.fontSize.xLarge,
            fontStyle: 'normal',
            fontWeight: theme.typography.fontWeight.normal,
            lineHeight: 'normal',
            opacity: 1
          }
        }
      }
    }
  }
})

type Props = InputProps & {
  name: string
  label: string
  helperText?: string
  variant?: 'standard' | 'outlined' | 'filled'
}

const ControlledTextFieldCustomLabel: FC<Props> = ({ label, variant, helperText, ...rest }) => (
  <ThemeProvider theme={muiTheme}>
    <FormControl
      variant={variant || 'standard'}
      className="controlled-text-field-custom-label-form-control"
      iserrored={helperText ? 'true' : 'false'}
    >
      <Typography className="form-control-label">
        {label} {rest.required && <span>*</span>}
      </Typography>
      <OutlinedInput {...rest} />
      {helperText && <Typography className="helper-text">{helperText}</Typography>}
    </FormControl>
  </ThemeProvider>
)

export default ControlledTextFieldCustomLabel
